import { render } from "./SupplyDetail.vue?vue&type=template&id=3ca1df08&scoped=true&ts=true&lang=pug"
import script from "./SupplyDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupplyDetail.vue?vue&type=script&lang=ts&setup=true"

import "./SupplyDetail.vue?vue&type=style&index=0&id=3ca1df08&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca1df08"]])

export default __exports__